import { DetectedEvent } from '@ais-ui/websockets';
import { useMemo } from 'react';

export function useEventSeverity(event: DetectedEvent) {
  const severity = useMemo(() => {
    switch (event.severity) {
      case 'WDESEV_NOTE':
        return 'note';
      case 'WDESEV_WARNING':
        return 'warning';
      case 'WDESEV_ALERT':
        return 'alert';
      default:
        return 'unknown'; // Handle the case where the severity doesn't match any known value
    }
  }, [event.severity]); // Depend on event.severity so that the hook recalculates the value if it changes

  return severity;
}
